import React from 'react';
import PropTypes from 'prop-types';
import store from '@Store';
import LoginFormHeader from '../../Components/LoginFormHeader';
import { openLoginModal } from '../../LoginActions';
import RegisterFormContent from './RegisterFormContent';

function RegisterModalForm(props) {
  const { ipAddress, isAnonymousUser, selfClose, onSignIn } = props;

  const handleSignIn =
    onSignIn ||
    (() => {
      selfClose?.();
      store.dispatch(openLoginModal());
    });

  return (
    <div className="login-form login-page-form-wrapper register-form">
      <LoginFormHeader
        ipAddress={ipAddress}
        isAnonymousUser={isAnonymousUser}
        cancel={selfClose}
        actionMessage="Create account"
        infoMessage="Complete this information to continue"
      />
      <RegisterFormContent {...props} isUsernameVisible={false} onSignIn={handleSignIn} />
    </div>
  );
}

RegisterModalForm.propTypes = {
  isAnonymousUser: PropTypes.bool,
  selfClose: PropTypes.func.isRequired,
  ipAddress: PropTypes.string,
  onSignIn: PropTypes.func,
};

export default RegisterModalForm;
